import { Link, NavLink } from "@remix-run/react";
import { Clapperboard, CircleUser, Menu, Package2 } from "lucide-react";
import { Button } from "./ui/button";
import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";

export default function Nav({ isAuthenticated }: { isAuthenticated: boolean }) {
  return (
    <header className="sticky top-0 flex h-16 items-center gap-4 border-b bg-background px-4 md:px-6 z-10">
      <div className="container flex h-14 max-w-screen-xl items-center mx-auto">
        <nav className="hidden flex-col gap-6 text-sm font-medium md:flex md:flex-row md:items-center md:gap-5 lg:gap-6 z-10">
          <Link
            to="/"
            className="flex items-center gap-2 text-lg font-semibold md:text-base"
          >
            <Clapperboard className="h-6 w-6" />
            <span className="sr-only">Hester Theater</span>
          </Link>
          <NavLink
            to="/"
            className={({ isActive }) =>
              `transition-colors hover:text-foreground ${
                isActive ? "text-foreground" : "text-muted-foreground"
              }`
            }
          >
            Showtimes
          </NavLink>
          <NavLink
            to="/reservations"
            className={({ isActive }) =>
              `transition-colors hover:text-foreground ${
                isActive ? "text-foreground" : "text-muted-foreground"
              }`
            }
          >
            My Reservations
          </NavLink>
        </nav>
        <Sheet>
          <SheetTrigger asChild>
            <Button
              variant="outline"
              size="icon"
              className="shrink-0 md:hidden"
            >
              <Menu className="h-5 w-5" />
              <span className="sr-only">Toggle navigation menu</span>
            </Button>
          </SheetTrigger>
          <SheetContent side="left">
            <nav className="grid gap-6 text-lg font-medium">
              <Link
                to="/"
                className="flex items-center gap-2 text-lg font-semibold"
              >
                <Package2 className="h-6 w-6" />
                <span className="sr-only">Hester Theater</span>
              </Link>
              <NavLink
                to="/"
                className={({ isActive }) =>
                  `transition-colors hover:text-foreground ${
                    isActive ? "text-foreground" : "text-muted-foreground"
                  }`
                }
              >
                Showtimes
              </NavLink>
              <NavLink
                to="/reservations"
                className={({ isActive }) =>
                  `transition-colors hover:text-foreground ${
                    isActive ? "text-foreground" : "text-muted-foreground"
                  }`
                }
              >
                My Reservations
              </NavLink>
            </nav>
          </SheetContent>
        </Sheet>
        <div className="flex  text-sm items-center gap-4 w-full md:w-auto md:ml-auto md:gap-2 lg:gap-4 justify-end">
          {isAuthenticated ? (
            <Link to="/kinde-auth/logout">Logout</Link>
          ) : (
            <Link to="/kinde-auth/login">Login</Link>
          )}
        </div>
      </div>
    </header>
  );
}
